import { render, staticRenderFns } from "./informacoesPessoais.vue?vue&type=template&id=1c2c3cce&scoped=true&"
import script from "./informacoesPessoais.vue?vue&type=script&lang=js&"
export * from "./informacoesPessoais.vue?vue&type=script&lang=js&"
import style0 from "./informacoesPessoais.vue?vue&type=style&index=0&id=1c2c3cce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c3cce",
  null
  
)

export default component.exports